/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';

const categoriesModule = require('@utils/categories/categoriesModule');
const cmsModule = require('@utils/cms/cmsModule');
const commonModule = require('@utils/common/commonModule');
const consumersModule = require('@utils/consumers/consumersModule');
const rebatesModule = require('@utils/rebates/rebatesModule');

const SpecialOffersService = require('./specialOffersService');
const SpecialOffersController = require('./specialOffersController');

const specialOffersModule = angular
    .module('enervee_utils.special_offers', [
        categoriesModule.name,
        cmsModule.name,
        commonModule.name,
        consumersModule.name,
        rebatesModule.name,
    ])
    .factory('SpecialOffersService', SpecialOffersService)
    .controller('SpecialOffersCtrl', SpecialOffersController);

module.exports = specialOffersModule;